import { wrapReducer } from "@client/content/lib/helper";
import { type ReduxAction } from "@client/types/ReduxAction";
import {
  Actions,
  type AddCommentSuccessData,
  type InitBeginActionData,
  type InitSuccessActionData,
  type LoadMoreBeginActionData,
  type LoadMoreSuccessActionData
} from "./actions";
import { type BlogDetailComments } from "./types";

const reducer = (state: BlogDetailComments.State, action: ReduxAction<any>): BlogDetailComments.State => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const { postId, page } = action.params as InitBeginActionData;
      const { areCommentsAllowed, commentCount, comments, hasMore } = action.data as InitSuccessActionData;
      return {
        ...state,
        areCommentsAllowed,
        commentCount,
        comments,
        hasMore,
        page,
        postId: postId!,
        status: "Ready"
      };
    }

    case Actions.AddCommentBegin: {
      return {
        ...state,
        status: "AddingComment"
      };
    }
    case Actions.AddCommentFailure: {
      return {
        ...state,
        status: "Ready"
      };
    }
    case Actions.AddCommentSuccess: {
      const comment = action.data as AddCommentSuccessData;
      return {
        ...state,
        comments: [comment, ...state.comments],
        status: "Ready"
      };
    }

    case Actions.LoadMoreBegin: {
      return {
        ...state,
        status: "LoadingMore"
      };
    }
    case Actions.LoadMoreFailure: {
      return {
        ...state,
        status: "Ready"
      };
    }
    case Actions.LoadMoreSuccess: {
      const { page } = action.params as LoadMoreBeginActionData;
      const { comments, hasMore } = action.data as LoadMoreSuccessActionData;
      return {
        ...state,
        comments: [...state.comments, ...comments],
        hasMore,
        page,
        status: "Ready"
      };
    }

    default:
      return state;
  }
};

export const defaultState: BlogDetailComments.State = {
  areCommentsAllowed: false,
  commentCount: 0,
  comments: [],
  hasMore: false,
  id: "",
  status: "None",
  page: 0,
  postId: ""
};
export const previewState: BlogDetailComments.State = {
  ...defaultState,
  areCommentsAllowed: true,
  commentCount: 1,
  comments: [
    {
      authorName: "Dummy",
      authorProfilePictureUrl: null,
      comment: "Dummy",
      createdOnDate: new Date().toISOString(),
      id: "",
      isApproved: true
    }
  ],
  hasMore: false,
  status: "Ready"
};
export default wrapReducer<BlogDetailComments.State>({ defaultState, reducer, previewState });
